export const sources = {
	avif: "__VITE_ASSET__Csiv01gp__ 443w",
	webp: "__VITE_ASSET__DsR8M6ds__ 443w"
};
export const img = {
	src: "__VITE_ASSET__D8AQXk_g__",
	w: 443,
	h: 473
};
export default {
	sources: sources,
	img: img
};
